import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { CustomReportsApiService } from 'src/services/customReportsApi'

export const useGetCustomReportsSummaryQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: () => CustomReportsApiService.getSummary(),
    queryKey: [QueryKey.GET_CUSTOM_REPORTS_SUMMARY],
  })
}
